<p-dialog
  [focusOnShow]="false"
  [visible]="visible()"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [header]="dialogTitle()"
  [style]="{ width: '600px' }"
  (onHide)="cancelDeliveryWindowForm()"
  (visibleChange)="toggleVisibility($event)"
  (onClose)="cancelDeliveryWindowForm()"
>
  <form (ngSubmit)="submitDeliveryWindowForm()">
    <div class="form-grid">
      <!-- Start Time Field -->
      <div class="datepicker-container">
        <p-floatLabel>
          <p-datePicker
            class="full-width-datepicker"
            hourFormat="12"
            dataType="string"
            name="startTime"
            [ngModel]="deliveryWindowForm.startTime().value()"
            [timeOnly]="true"
            (ngModelChange)="deliveryWindowForm.startTime().value.set($event)"
          ></p-datePicker>
          <label for="startTime">Start Time *</label>
          @if (deliveryWindowForm.startTime().touched() && deliveryWindowForm.startTime().invalid()) {
            <p-message class="error-message" severity="error">Invalid Start Time</p-message>
          }
        </p-floatLabel>

        <p-floatLabel>
          <p-datePicker
            class="full-width-datepicker"
            hourFormat="12"
            dataType="string"
            name="endTime"
            [ngModel]="deliveryWindowForm.endTime().value()"
            [timeOnly]="true"
            (ngModelChange)="deliveryWindowForm.endTime().value.set($event)"
          ></p-datePicker>
          <label for="endTime">End Time *</label>
        </p-floatLabel>
      </div>
      @for (error of deliveryWindowForm.endTime().errors(); track error.kind) {
        <p-message severity="error">{{ error.message }}</p-message>
      }

      <!-- Max Deliveries Field -->
      <div class="form-field">
        <p-floatLabel>
          <p-inputNumber
            class="input-full-width"
            data-testid="delivery-window-capacity"
            name="maxDeliveries"
            [ngModel]="deliveryWindowForm.maxDeliveriesPerDay().value()"
            [min]="1"
            [max]="999"
            (ngModelChange)="deliveryWindowForm.maxDeliveriesPerDay().value.set($event)"
          />
          <label for="maxDeliveries">Max Deliveries *</label>
        </p-floatLabel>
        @if (deliveryWindowForm.maxDeliveriesPerDay().touched() && deliveryWindowForm.maxDeliveriesPerDay().invalid()) {
          <p-message class="error-message" severity="error">Invalid Max Deliveries</p-message>
        }
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="dialog-footer-actions">
      <p-button label="Cancel" [text]="true" (onClick)="cancelDeliveryWindowForm()" />
      <p-button
        data-testid="delivery-window-save"
        label="Save"
        [loading]="loading()"
        [disabled]="loading() || deliveryWindowForm().invalid()"
        (onClick)="submitDeliveryWindowForm()"
      />
    </div>
  </ng-template>
</p-dialog>
